/**
 * Migrates legacy chip-selector data to the new chip-multi-context shape.
 *
 * Old shape: { selections: [{ chip: "decide", note: "..." }, ...] }
 * New shape: { selections: [{ chipId: "decide", context: "...", selectedAt: "..." }, ...] }
 */
export function migrateChipContextData(raw) {
  if (!raw) return { selections: [] }

  // Already in new format
  if (raw.selections && raw.selections.length > 0 && raw.selections[0].chipId) {
    return raw
  }

  // Old format: { selections: [{ chip, note }] }
  if (Array.isArray(raw.selections) && raw.selections.length > 0 && raw.selections[0].chip !== undefined) {
    return {
      selections: raw.selections.map((s) => ({
        chipId: s.chip,
        context: s.note ?? '',
        selectedAt: new Date('2026-01-01T00:00:00Z').toISOString(),
      })),
    }
  }

  // Fallback: { selected: [...], contexts: {...} }
  if (Array.isArray(raw.selected)) {
    return {
      selections: raw.selected.map((chipId) => ({
        chipId,
        context: raw.contexts?.[chipId] ?? '',
        selectedAt: new Date('2026-01-01T00:00:00Z').toISOString(),
      })),
    }
  }

  // Empty selections if nothing matches
  if (Array.isArray(raw.selections) && raw.selections.length === 0) {
    return { selections: [] }
  }

  return { selections: [] }
}
